module.exports = __webpack_public_path__ + "media/images/fact_sheet_mirror-d1999a6338d96c183c8498149bb96e59.png";